/**
 * Registrations store — pending document review counter.
 *
 * Mirrors the Alpine `$store.registrations.pendingDocs` of the legacy panel
 * (RF29). The Sidebar reads this value to render a badge on the "Cadastros"
 * nav item; a future polling hook (TASK-024) will call `setPendingDocs` from
 * `GET /api/v1/admin/users?documentStatus=PENDING&size=1`.
 */
import { create } from 'zustand';

interface RegistrationsState {
  pendingDocs: number;
  setPendingDocs: (n: number) => void;
}

export const useRegistrationsStore = create<RegistrationsState>((set) => ({
  pendingDocs: 0,
  setPendingDocs: (n) => set({ pendingDocs: n }),
}));
